/**
 * @selector [data-js-mobilenav]
 */
import BaseModule from '../../modules/BaseModule.js';
import * as focusTrap from 'focus-trap';

export default class SiteNav extends BaseModule {
    constructor() {
        super();
    }

    init(element) {
        this.el = element;

        this.focusTrap = focusTrap.createFocusTrap(this.el, {
            fallbackFocus: '[data-js-mobilenav-action]',
        });

        this.bindListeners();

        return this;
    }

    bindListeners() {
        this.on(document, 'click', '[data-js-mobilenav-action="open"]', this.onOpenClick);
        this.on(document, 'click', '[data-js-mobilenav-action="close"]', this.onCloseClick);

        this.on(document, 'keydown', this.onKeyDown);
    }

    onKeyDown(e) {
        if (e.key === 'Escape') {
            this.close();
        }
    }

    onOpenClick(e) {
        e.preventDefault();

        this.open();
    }

    onCloseClick(e) {
        e.preventDefault();

        this.close();
    }

    open() {
        this.focusTrap.activate();

        this.el.classList.add('is-open');
        document.documentElement.classList.add('is-nav-open');
    }

    close() {
        this.focusTrap.deactivate();

        this.el.classList.remove('is-open');
        document.documentElement.classList.remove('is-nav-open');
    }

    destroy() {
        this.close();
        super.destroy();
    }
}
